var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a",
        { staticClass: "skip-to-main", attrs: { href: "#main-content" } },
        [_vm._v("Skip to main content")]
      ),
      _vm._v(" "),
      !_vm.embed
        ? _c(
            "div",
            { staticClass: "wrap" },
            [
              _c(
                "v-toolbar",
                {
                  staticStyle: { "margin-bottom": "-50px", height: "60px" },
                  attrs: {
                    color: "#005cb8",
                    flat: "",
                    dense: "",
                    role: "banner"
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "mx-2 pa-0",
                      staticStyle: {
                        width: "220px",
                        height: "60px",
                        overflow: "hidden"
                      },
                      attrs: {
                        href: "https://arlingtonva.us",
                        "aria-label": "Arlington County Virginia home"
                      }
                    },
                    [
                      _c("v-img", {
                        staticClass: "my-auto",
                        attrs: {
                          "max-width": "200",
                          position: "top, left",
                          src:
                            "https://arlingtonva.s3.amazonaws.com/wp-content/CountyLogo_Reverse_Horizontal.png",
                          alt: "Arlington County Virginia"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-toolbar-items")
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-app",
        { class: { embedded: _vm.embed }, attrs: { id: "main-content" } },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      !_vm.embed
        ? _c("v-footer", { attrs: { color: "#005cb8", role: "contentinfo" } }, [
            _c("p", { staticClass: "ma-auto white--text body-2" }, [
              _vm._v(
                "Copyright © " +
                  _vm._s(new Date().getFullYear()) +
                  " Arlington County Virginia"
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2e795e3e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e795e3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = ftcW
// module chunks = 1